import { Component, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-adjustment-code',
  templateUrl: './adjustment-code.component.html',
  styleUrls: ['./adjustment-code.component.css'],
})
export class AdjustmentCodeComponent implements OnInit {
  adjustmentCodeForm: FormGroup;

  //#region  Properties

  public get adjustmentCode1(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode1') as FormControl
  }

  get adjustmentCode2(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode2') as FormControl
  }

  get adjustmentCode3(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode3') as FormControl
  }

  get adjustmentCode4(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode4') as FormControl
  }

  get adjustmentCode5(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode5') as FormControl
  }

  get adjustmentCode6(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode6') as FormControl
  }

  get adjustmentCode7(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode7') as FormControl
  }

  get adjustmentCode8(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode8') as FormControl
  }

  get adjustmentCode9(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode9') as FormControl
  }

  get adjustmentCode10(): FormControl {
    return this.adjustmentCodeForm.get('adjustmentCode10') as FormControl
  }

  //#endregion

  constructor(private builder: FormBuilder) { }

  ngOnInit() {
    this.initForm()
  }

  private initForm(): void {
    this.adjustmentCodeForm = this.builder.group({
      adjustmentCode1: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode2: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode3: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode4: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode5: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode6: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode7: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode8: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode9: this.builder.control('', [
        Validators.maxLength(10),
      ]),
      adjustmentCode10: this.builder.control('', [
        Validators.maxLength(10),
      ]),
    });

    //  Disable all adjustment codes except the first one by default.
    this.adjustmentCode2.disable()
    this.adjustmentCode3.disable()
    this.adjustmentCode4.disable()
    this.adjustmentCode5.disable()
    this.adjustmentCode6.disable()
    this.adjustmentCode7.disable()
    this.adjustmentCode8.disable()
    this.adjustmentCode9.disable()
    this.adjustmentCode10.disable()

    //  When an adjustment code field has a value, enable the next field or
    //  disable it if the current field has no value (or value has been removed)
    this.adjustmentCode1.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode2.dirty)) ? this.adjustmentCode2.enable() : this.adjustmentCode2.disable()
    })
    this.adjustmentCode2.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode3.dirty)) ? this.adjustmentCode3.enable() : this.adjustmentCode3.disable()
    })
    this.adjustmentCode3.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode4.dirty)) ? this.adjustmentCode4.enable() : this.adjustmentCode4.disable()
    })
    this.adjustmentCode4.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode5.dirty)) ? this.adjustmentCode5.enable() : this.adjustmentCode5.disable()
    })
    this.adjustmentCode5.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode6.dirty)) ? this.adjustmentCode6.enable() : this.adjustmentCode6.disable()
    })
    this.adjustmentCode6.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode7.dirty)) ? this.adjustmentCode7.enable() : this.adjustmentCode7.disable()
    })
    this.adjustmentCode7.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode8.dirty)) ? this.adjustmentCode8.enable() : this.adjustmentCode8.disable()
    })
    this.adjustmentCode8.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode9.dirty)) ? this.adjustmentCode9.enable() : this.adjustmentCode9.disable()
    })
    this.adjustmentCode9.valueChanges.subscribe((value) => {
      ((value) || (this.adjustmentCode10.dirty)) ? this.adjustmentCode10.enable() : this.adjustmentCode10.disable()
    })
  }

  resetForm(): void {
    this.adjustmentCodeForm.patchValue({
      adjustmentCode1: '',
      adjustmentCode2: '',
      adjustmentCode3: '',
      adjustmentCode4: '',
      adjustmentCode5: '',
      adjustmentCode6: '',
      adjustmentCode7: '',
      adjustmentCode8: '',
      adjustmentCode9: '',
      adjustmentCode10: '',
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/remittance-entry/adjustment-code/adjustment-code.component.ts